<!--
  This one may be a genuine problem rather than a false positive. The element
  sets aria-expanded, so it presents as a disclosure widget, but it is a plain
  div with no focus and no key handling. Not verified with a keyboard yet.
-->
<div
  name="collapseButton"
  class="collapse-toggle"
  (click)="toggleCollapsed()"
  [attr.aria-expanded]="!collapsed"
>
  <ng-content select="[collapseToggle]" />
</div>
<div name="collapseWrapper" class="collapse-wrapper">
  <ng-content />
</div>
